import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (e, id) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-900 text-stone-300 py-16 mt-auto">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          
          <div>
            <div className="mb-6">
              <a href="/" onClick={(e) => handleNavClick(e, 'hem')}>
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/5c1e3a15fc68e7fca62dc4ec64936fd2c3f13f974599de31727b7a91865820cd8939af7242306cdc50be50497057948e/images/aW1hZ2UvcG5n/d6937394eb4d6a56959e8c727708d311.png" 
                  alt="Starkare Logo" 
                  className="h-24 w-auto object-contain"
                />
              </a>
            </div>
            <p className="text-stone-400 font-light max-w-sm leading-relaxed">
              Legitimerad sjuksköterska, personlig tränare och kostrådgivare. För dig som vill skapa hälsosamma vanor som håller över tid.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm uppercase tracking-widest mb-6">Länkar</h4>
            <ul className="space-y-3 font-light">
              <li><a href="#om" onClick={(e) => handleNavClick(e, 'om')} className="hover:text-white transition-colors">Om mig</a></li>
              <li><a href="#filosofi" onClick={(e) => handleNavClick(e, 'filosofi')} className="hover:text-white transition-colors">Min Filosofi</a></li>
              <li><a href="#tjanster" onClick={(e) => handleNavClick(e, 'tjanster')} className="hover:text-white transition-colors">Tjänster & Paket</a></li>
              <li><a href="#priser" onClick={(e) => handleNavClick(e, 'priser')} className="hover:text-white transition-colors">Prislista</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm uppercase tracking-widest mb-6">Kontakt</h4>
            <ul className="space-y-3 font-light mb-6">
              <li>Måndag - Fredag: 08:00 - 17:00</li>
              <li>
                <a href="mailto:hej@starkaremeddiana.se" className="hover:text-white transition-colors">
                  hej@starkaremeddiana.se
                </a>
              </li>
            </ul>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 border border-stone-700 flex items-center justify-center hover:bg-white hover:text-stone-900 transition-all duration-300">
                <SafeIcon icon={FiIcons.FiInstagram} />
              </a>
              <a href="#" className="w-10 h-10 border border-stone-700 flex items-center justify-center hover:bg-white hover:text-stone-900 transition-all duration-300">
                <SafeIcon icon={FiIcons.FiFacebook} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="pt-8 border-t border-stone-800 text-xs tracking-wider text-stone-500 flex flex-col md:flex-row justify-between items-center font-light">
          <p>&copy; {new Date().getFullYear()} Starkare med Diana. Alla rättigheter förbehållna.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;